import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { PackageModel } from '@data-layer/models/lcl';
import { enumLengthUnit, enumWeightUnit } from '@data-layer/enums/common';
import { precisionRound } from '@helpers/data-transform.helper';
import { METRE_CENTIMETER_RATIO } from '@constants/constants';
import { enumPackageType, enumPalletStandard } from '@data-layer/enums/lcl';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-lcl-shipping-package-item-view',
  templateUrl: './lcl-shipping-package-item-view.component.html',
  styleUrls: ['./lcl-shipping-package-item-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LclShippingPackageItemViewComponent {
  @Input() public package: PackageModel;
  @Input() public isLastest: boolean;
  @Input() public isAdminView: boolean;
  @Input() public isCanEdit: boolean = true;
  @Input() public isCanDelete: boolean = true;
  @Output() public editPackage: EventEmitter<void> = new EventEmitter<void>();
  @Output() public removePackage: EventEmitter<void> = new EventEmitter<void>();

  constructor(private translateService: TranslateService) {}

  public get normalizedLength(): number {
    return this.package.lengthUnit === enumLengthUnit.METER
      ? precisionRound(this.package.dimensions.length * METRE_CENTIMETER_RATIO)
      : this.package.dimensions.length;
  }

  public get normalizedWidth(): number {
    return this.package.lengthUnit === enumLengthUnit.METER
      ? precisionRound(this.package.dimensions.width * METRE_CENTIMETER_RATIO)
      : this.package.dimensions.width;
  }

  public get normalizedHeight(): number {
    return this.package.lengthUnit === enumLengthUnit.METER
      ? precisionRound(this.package.dimensions.height * METRE_CENTIMETER_RATIO)
      : this.package.dimensions.height;
  }

  public get typeName(): string {
    return this.translateService.instant('PACKAGE_TYPE.' + enumPackageType[this.package.type]);
  }

  public get lengthName(): string {
    const lengthUnit: number = this.package.lengthUnit === enumLengthUnit.METER ? enumLengthUnit.CENTIMETER : this.package.lengthUnit;

    return this.translateService.instant('LENGTH_UNIT.' + enumLengthUnit[lengthUnit]);
  }

  public get weightName(): string {
    return this.translateService.instant('WEIGHT_UNIT.' + enumWeightUnit[this.package.weightUnit]);
  }

  public get isShowPallet(): boolean {
    return this.package.type === enumPackageType.PALLET;
  }

  public get isShowPalletStandardInput(): boolean {
    return (
      this.isShowPallet &&
      [enumPalletStandard.GMA, enumPalletStandard.EUR_1, enumPalletStandard.EUR_2].includes(this.package.palletStandard)
    );
  }

  public get palletStandard(): boolean {
    return this.translateService.instant('PALLET_TYPES.' + enumPalletStandard[this.package.palletStandard]);
  }

  public get palletStandardMobile(): boolean {
    return this.translateService.instant('PALLET_TYPES_MOBILE.' + enumPalletStandard[this.package.palletStandard]);
  }
}
